import { gql } from '@apollo/client';
export const CLIENT_FIELDS_OF_STUDY = gql `
  query CLIENT_FIELDS_OF_STUDY($spec: ClientFieldOfStudySpec!) {
    clientFieldsOfStudy(spec: $spec) {
      total
      page
      pageSize
      items {
        id
        fieldOfStudyId
        isActive
        createdAt
        updatedAt
        fieldOfStudy {
          id
          category
          name
          isActive
          content {
            id
            clientId
            contentType
            code
            name
          }
        }
      }
    }
  }
`;
export const SAVE_CLIENT_FIELD_OF_STUDY = gql `
  mutation SAVE_CLIENT_FIELD_OF_STUDY($input: ClientFieldOfStudyInput!) {
    saveClientFieldOfStudy(input: $input) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
export const UPDATE_CLIENT_FIELD_OF_STUDY = gql `
  mutation UPDATE_CLIENT_FIELD_OF_STUDY(
    $input: ClientFieldOfStudyInput!
    $spec: ClientFieldOfStudySpec!
  ) {
    updateClientFieldOfStudy(input: $input, spec: $spec) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
